import { useOrganisation } from "~/contexts/organisation-provider";
import { OrganisationMembersTable } from "./components/organisation-members-table";
import { AddOrganisationMemberModal } from "./components/add-organisation-member-modal";
import { SwitchOrganisationModal } from "./components/switch-organisation-modal";

export const OrganisationMembersPage = () => {
  const { organisation, members } = useOrganisation();

  if (!organisation) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <SwitchOrganisationModal />
        <AddOrganisationMemberModal />
      </div>

      <OrganisationMembersTable members={members} />
    </div>
  );
};
